<div *ngIf="loading && !isSyncInProgress && !isLoadInProgress && !showContent" align="center">
	<br />
	<div class="loader"></div>
</div>
<div [hidden]="!isLoadInProgress">
	<h3 [hidden]="hiddenTitle" align="center">Loading Inventory</h3>
	<app-progress-bar
		[data]="progressBarLoadOnHand"
		(onProgress)="loadInProgress()"
		(onFinish)="finishLoad()"
	></app-progress-bar>
</div>
<div [hidden]="!isCompareInProgress">
	<h3 [hidden]="hiddenTitle" align="center">Compare Inventory</h3>
	<app-progress-bar
		[data]="progressBarCompareOnHand"
		(onProgress)="compareInProgress()"
		(onFinish)="compareDone()"
	></app-progress-bar>
</div>
<div [hidden]="!(isSyncInProgress && showContent)">
	<h3 align="center">Syncing Inventory Counts to {{ data.platform }}</h3>
	<app-progress-bar
		[data]="progressBarSyncInventory"
		(onProgress)="inProgress()"
		(onFinish)="finishSync()"
	></app-progress-bar>
</div>
<ng-container *ngIf="!loading && syncTab">
	<app-sync-history [data]="data"></app-sync-history>
</ng-container>
<ng-container
	*ngIf="!loading && !syncTab && !isSyncInProgress && !isLoadInProgress && !isCompareInProgress && showContent"
>
	<div class="page-wrapper">
		<div class="top-section">
			<div class="last-sync-and-buttons-container">
				<div
					class="last-sync-date-list"
					[ngClass]="{
						'inventory-status-completed': inventoryStatus == 'completed',
						'inventory-status-expired': inventoryStatus != 'completed'
					}"
				>
					<div class="last-sync-date-list-item">
						<span class="title">Last Audit Date:</span>
						<span
							class="date-string-container"
							[ngClass]="{
								'app-text-danger': !lastAuditDate
							}"
						>
							{{ lastAuditDate ? (lastAuditDate | localDate) : 'N/A' }}
						</span>
					</div>
					<div class="last-sync-date-list-item">
						<span class="title">Last Scan Date:</span>
						<span
							class="date-string-container"
							[ngClass]="{
								'app-text-danger': !lastScanDate
							}"
						>
							{{ lastScanDate ? (lastScanDate | localDate) : 'N/A' }}

							@if(inventoryStatus !== 'error'){
							<i
								class="mdi mdi-leaf"
								[ngClass]="{
									'app-text-success': inventoryStatus == 'completed',
									'app-text-warning': inventoryStatus !== 'completed',
								}"
							></i>
							} @else {
							<i class="mdi mdi-alert-circle app-text-danger"></i>
							}
						</span>
					</div>
					<div class="last-sync-date-list-item">
						<span class="title">Last Sync Date:</span>
						<span
							class="date-string-container"
							[ngClass]="{
								'app-text-danger': !lastSyncDate
							}"
						>
							{{ lastSyncDate ? (lastSyncDate | localDate) : 'N/A' }}
						</span>
					</div>
					<div class="last-sync-date-list-item">
						<span class="title"> Last OnHand Load: </span>
						<span
							class="date-string-container"
							[ngClass]="{
								'app-text-danger': !loadDate
							}"
							>{{ loadDate ? (loadDate | localDate) : 'N/A' }}</span
						>
					</div>
				</div>
				<div class="load-buttons-container">
					<button type="submit" class="btn btn-primary" (click)="confirmToLoad()">RFID vs. On Hand</button>
					<button
						[disabled]="!loadDate"
						type="submit"
						class="btn btn-primary"
						(click)="compareOnHandInventory()"
					>
						Reload Verified RFID
					</button>
				</div>
			</div>

			<!-- <div class="modal align-middle" style="display: block;" *ngIf="isShowSpreadsheetPopup">
      		<div class="modal-dialog modal-dialog-centered">
      		  <div class="modal-content">
      		    <div class="modal-header">
      		      <h5 class="modal-title">Inventory Spreadsheet download</h5>
      		      <button class="close" (click)="closePopup()">&times;</button>
      		    </div>
      		    <div class="modal-footer">
      		      <button class="btn btn-info simpleRfIdColor" (click)="getXmlCsvSpreadsheetOnHand('xlsx')">XLSX</button>
      		      <button class="btn btn-info simpleRfIdColor" (click)="getXmlCsvSpreadsheetOnHand('csv')">CSV</button>
      		    </div>
      		  </div>
      		</div>
    	</div> -->
			<!-- <div class="margin-right" style="padding-top: 4px">
			<div *ngIf="isShowSpreadsheetButton">
			  <span (click)="openPopup()" title="Download spreadsheet. Select a products."><i class="fas fa-file-download fa-2x" style="color: rgb(84, 143, 214)"></i></span>
			</div>
			<div *ngIf="!isShowSpreadsheetButton">
			  <span (click)="openPopup()" title="Download spreadsheet. Select a products."><i class="fas fa-file-download fa-2x" style="color: rgb(149, 214, 234)"></i></span>
			</div>
		</div> -->
			<div class="right-side-controls">
				<div class="check-input-container">
					<input
						id="displayNeverPrintedScanned"
						type="checkbox"
						[(ngModel)]="settings.DisplayNeverPrintedScanned"
						(ngModelChange)="updateSetting()"
					/>
					<label for="displayNeverPrintedScanned">
						Display never printed/scanned products in Compare On Hand
					</label>
				</div>
				<div class="buttons-list">
					<button
						class="btn btn-primary sync-box-button-history"
						(click)="getReport()"
						[disabled]="filteredItems.length == 0"
					>
						<i class="mdi mdi-calendar-month-outline"></i>
						Get Report
					</button>

					<button class="btn btn-primary history-btn" (click)="changeTab()">
						<i class="mdi mdi-calendar-month-outline"></i>
						History
					</button>
					<button
						*ngIf="activeSourceTab == InventorySource.Mismatch && auditInProgress"
						type="submit"
						class="btn btn-primary sync-box-button-other"
						[disabled]="countToSync === 0 || isSyncInProgress"
						(click)="confirmToUpdateOnHand(null)"
						title="Items to sync: {{ itemsToSync }}"
					>
						Sync
						<span class="items-counter" *ngIf="inventoryStorage.isFirstloaded && countToSync > 0">
							({{ countToSync }})
						</span>
					</button>
					<button
						*ngIf="activeSourceTab == InventorySource.Mismatch"
						type="submit"
						class="btn btn-primary sync-box-button-other"
						(click)="openPrintModal()"
						[disabled]="!isPrintingEnable"
						[ngbTooltip]="isPrintingEnableTitle"
						[openDelay]="300"
						[closeDelay]="300"
					>
						Print
						<span class="items-counter" *ngIf="inventoryStorage.isFirstloaded && countItemsToPrint > 0">
							({{ countItemsToPrint }})
						</span>
					</button>
				</div>
			</div>
		</div>
		<div class="middle-section">
			<div class="search-wrapper">
				<input
					class="form-control"
					[(ngModel)]="searchString"
					(ngModelChange)="getInventoryTabOnHand()"
					placeholder="Search..."
				/>
			</div>
			<div class="table-mode-switcher">
				<button
					class="btn btn-primary table-mode-btn mismatch-btn"
					[ngClass]="{ active: activeSourceTab == InventorySource.Mismatch }"
					(click)="getMismatchInventoryOnHand()"
				>
					Mismatch
					<span
						class="items-counter"
						*ngIf="inventoryStorage.isFirstloaded && inventoryStorage.inventorySyncCount > 0"
					>
						({{ inventoryStorage.inventorySyncCount }})
					</span>
				</button>
				<button
					class="btn btn-primary table-mode-btn match-btn"
					[ngClass]="{ active: activeSourceTab == InventorySource.Match }"
					(click)="getMatchInventoryOnHand()"
				>
					Match
					<span
						class="items-counter"
						*ngIf="inventoryStorage.isFirstloaded && inventoryStorage.inventoryMatchCount > 0"
					>
						({{ inventoryStorage.inventoryMatchCount }})
					</span>
				</button>
			</div>
			@if(activeSourceTab == InventorySource.Mismatch){
			<div class="table-filter-buttons">
				<button
					class="btn btn-all"
					[ngClass]="{ active: activeFilterColor == 'white' }"
					(click)="lineFilterOnHand(colorFilters.default)"
				>
					All
					<span
						class="items-counter"
						*ngIf="inventoryStorage.isFirstloaded && inventoryStorage.inventorySyncCount > 0"
					>
						({{ inventoryStorage.inventorySyncCount }})
					</span>
				</button>
				<button
					class="btn btn-deflated"
					[ngClass]="{ active: activeFilterColor == 'green' }"
					(click)="lineFilterOnHand(colorFilters.deflatedFilter)"
				>
					Deflated
					<span
						class="items-counter"
						*ngIf="inventoryStorage.isFirstloaded && inventoryStorage.inventoryDeflatedCount > 0"
					>
						({{ inventoryStorage.inventoryDeflatedCount }})
					</span>
				</button>
				<button
					class="btn btn-inflated"
					[ngClass]="{ active: activeFilterColor == 'red' }"
					(click)="lineFilterOnHand(colorFilters.inflatedFilter)"
				>
					Inflated
					<span
						class="items-counter"
						*ngIf="inventoryStorage.isFirstloaded && inventoryStorage.inventoryInflatedCount > 0"
					>
						({{ inventoryStorage.inventoryInflatedCount }})
					</span>
				</button>
				<button
					class="btn btn-oos"
					[ngClass]="{ active: activeFilterColor == 'oss' }"
					(click)="lineFilterOnHand(colorFilters.OoSFilter)"
				>
					Out of stock
					<span
						class="items-counter"
						*ngIf="inventoryStorage.isFirstloaded && inventoryStorage.inventoryOutOfStockCount > 0"
					>
						({{ inventoryStorage.inventoryOutOfStockCount }})
					</span>
				</button>
			</div>
			}
		</div>

		<div class="div-table-wrapper">
			<!-- Header as div-based table -->
			<div class="header-row">
				<div class="header-cell col-img">Image</div>
				<div class="header-cell col-title">Product Name</div>
				<div class="header-cell col-key">{{ productKey }}</div>
				<div class="header-cell col-rfid">Verified RFID</div>
				<div class="header-cell col-orders" *ngIf="auditInProgress">- Fulfilled Orders =</div>
				<div class="header-cell col-projected" *ngIf="auditInProgress">Projected On Hand</div>
				<div class="header-cell col-current">Shopify On Hand</div>
				<div class="header-cell col-sync-btn" *ngIf="activeSourceTab == InventorySource.Mismatch"></div>
				<div class="header-cell col-sync-check" *ngIf="activeSourceTab == InventorySource.Mismatch">
					<input
						type="checkbox"
						name="syncAll"
						[(ngModel)]="syncAll"
						[checked]="syncAll"
						(ngModelChange)="adjustSelectionOnHand()"
						[disabled]="selectAllDisabled"
					/>
				</div>
				<div class="header-cell scroll-gap"></div>
			</div>

			<!-- Totals row -->
			@if(inventoryStorage.isFirstloaded && auditInProgress){
			<div class="header-row second-header">
				<div class="header-cell col-img"></div>
				<div class="header-cell col-title"></div>
				<div class="header-cell col-key"></div>
				<div class="header-cell col-rfid">
					{{ getRfidTotalCount() }}
				</div>
				<div class="header-cell col-orders">
					{{ getOrderTotalCount() }}
				</div>
				<div class="header-cell col-projected">
					{{ getProjectedTotalCount() }}
				</div>
				<div class="header-cell col-current">
					{{ getOnHandTotalCount() }}
				</div>
				@if(activeSourceTab == InventorySource.Mismatch){
				<div class="header-cell col-sync-btn"></div>
				<div class="header-cell col-sync-check"></div>
				}
				<div class="header-cell scroll-gap"></div>
			</div>
			}

			<!-- Body: Virtual scroll with div rows -->
			<cdk-virtual-scroll-viewport class="scroll-viewport" [itemSize]="64" [bufferSize]="50">
				<div
					*cdkVirtualFor="let product of filteredItems; let i = index"
					class="table-row"
					[ngClass]="
						activeSourceTab != InventorySource.NeverPrinted
							? {
									'background-green': product.FilterType == 'Deflated',
									'background-orange': product.FilterType == 'Inflated',
									'background-red': product.FilterType == 'OutOfStock'
							  }
							: ''
					"
				>
					<div class="table-cell col-img">
						<div class="table-img-box">
							<app-image-handler [product]="product"></app-image-handler>
						</div>
					</div>
					<div class="table-cell col-title">{{ product.Title }}</div>
					<div class="table-cell col-key">{{ product.Sku }}</div>
					<div class="table-cell col-rfid">{{ product.RfidCount }}</div>
					<div
						class="table-cell col-orders"
						[ngClass]="{ 'clickable-cell': product.OrdersCount !== 0 }"
						(click)="openOrdersInfoModal(product)"
					>
						{{ product.OrdersCount }}
					</div>
					<div class="table-cell col-projected">{{ product.NewCount }}</div>
					<div class="table-cell col-current" [ngClass]="{ 'app-text-danger': product.isAdjusted }">
						{{ product.CurrentCount }}
					</div>

					<!-- Sync button column -->
					<div class="table-cell col-sync-btn" *ngIf="activeSourceTab == InventorySource.Mismatch">
						<button
							*ngIf="product.NewCount >= 0 && product.NewCount != product.CurrentCount"
							type="submit"
							class="btn btn-info simpleRfIdColor"
							[disabled]="isSyncInProgress"
							(click)="oneUpdateOnHand(product)"
							title="Click to sync"
						>
							Sync
						</button>
					</div>

					<!-- Checkbox column -->
					<div class="table-cell col-sync-check" *ngIf="activeSourceTab == InventorySource.Mismatch">
						<input
							type="checkbox"
							name="sync{{ i }}"
							[checked]="product.sync"
							(change)="changeSelectionOnHand(product)"
							(click)="toggleSelected(i, $event)"
							[disabled]="product.NewCount < 0"
							oninput="this.value = this.value.replace(/\D/g, '')"
						/>
					</div>
				</div>
			</cdk-virtual-scroll-viewport>
		</div>
		<!--<div  *ngIf="auditInProgress" class="row" style="margin-left: 0;  margin-right: 0;">
    <div class="col-md-3 offset-md-7 text-center">
      <ng-container *ngIf="allowMakeVisible">
        <span style="padding-top:5px;">
          <input type="checkbox" name="makeVisible" [(ngModel)]="makeVisible">&nbsp;<label for="makeVisible">Make visible</label>
        </span>
      </ng-container>
    </div>
  </div>-->
		<!-- <div *ngIf="auditInProgress && filteredItems.length > 0" style="text-align: end; margin-top: 25px">
			<button
				*ngIf="activeSourceTab == InventorySource.Mismatch"
				type="submit"
				class="btn btn-info simpleRfIdColor sync-box-button-other"
				[disabled]="countToSync === 0 || isSyncInProgress"
				(click)="confirmToUpdateOnHand(null)"
				title="Items to sync: {{ itemsToSync }}"
			>
				Sync
				<span *ngIf="inventoryStorage.isFirstloaded">({{ countToSync }})</span>
			</button>
			<button
				*ngIf="activeSourceTab == InventorySource.Mismatch"
				type="submit"
				class="btn btn-info simpleRfIdColor sync-box-button-other"
				[disabled]="!isPrintingEnable"
				[ngbTooltip]="isPrintingEnableTitle"
				[openDelay]="300"
				[closeDelay]="300"
				(click)="openPrintModal()"
			>
				Print
				<span *ngIf="inventoryStorage.isFirstloaded">({{ countItemsToPrint }})</span>
			</button>
		</div> -->
	</div>
</ng-container>
